import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postDiameter } from '../Api'

export default generateApiAction({
  baseType: Types.DIAMETERS.POST,
  api: postDiameter,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/diameters/PostAction.js